/* global modForm */
/**
 * Check form configuration for required settings
 * @returns {boolean} - true if valid, false if not
 */
export function isConfigValid() {
	const errors = [];
	if (modForm.opts.vertical === null) {
		errors.push('Please define the vertical.');
	}
	if (modForm.opts.form === null || !modForm.opts.form.length) {
		errors.push('Please define the form element.');
	}
	if (!document.querySelector(modForm.opts.stepsSelector)) {
		errors.push('Please form steps.');
	}
	if (errors.length) {
		alert(errors.join('\n'));
		return false;
	}
	return true;
}
